// src/components/CancellationPolicy.js
import React from 'react';
import PolicyPage from './PolicyPage';

function CancellationPolicy() {
  return (
    <PolicyPage title="Cancellation Policy" lastUpdated="[Date]">
      <h2>1. Order Cancellation by Customer</h2>
      <ul>
        <li>You may cancel your order before the scheduled pickup time via the IronBhai app or by contacting customer support.</li>
        <li>If the pickup process has already started, cancellation may not be possible, and the service charge may still apply.</li>
      </ul>
      <h2>2. Order Cancellation by IronBhai</h2>
      <p>We may cancel your order in cases such as:</p>
      <ul>
        <li>Service unavailability in your area.</li>
        <li>Incorrect or incomplete order details.</li>
        <li>Unforeseen operational issues.</li>
        <li>Violation of our Terms &amp; Conditions.</li>
      </ul>
      <h2>3. Refunds for Cancelled Orders</h2>
      <ul>
        <li>For prepaid orders cancelled before pickup, a full refund will be issued within 7-10 business days to the original payment method.</li>
        <li>No refund will be provided if the garments have already been processed.</li>
      </ul>
      <h2>4. Rescheduling Instead of Cancellation</h2>
      <ul>
        <li>Customers can request a change in pickup/delivery slot before the scheduled time, subject to slot availability.</li>
      </ul>
      <h2>5. Contact for Cancellations</h2>
      <p className="contact">📧 Email: support@ironbhai.com<br />
      📞 Phone: +91 8688206969</p>
    </PolicyPage>
  );
}

export default CancellationPolicy;
